let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kaWHz")).then(() => parcelRequire('19vLN'));